import store from 'js/store/index'
import { action } from 'js/actions/index'

window.store = store
window.updateAccessPoint = action
